export default function() {
  return Math.random();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-random/src/defaultSource.js
// module id = 23
// module chunks = 0 1 2 3 4